import { useIsEditForm } from "@/widgets/classic-form/IsEditFormContext";
import { Subscribe } from "@/widgets/classic-form/form";
import type { SubmitBtnAttributes } from "@/entities/form-metadata";
import { Submit } from "./Submit";

export const SubmitSection = ({ label }: SubmitBtnAttributes) => {
    const isEditForm = useIsEditForm();

    return (
        <Subscribe
            selector={({ isDirty, isSubmitting }) => ({
                disabled: isEditForm ? isSubmitting : isSubmitting || !isDirty,
                isSubmitting,
            })}
            children={({ disabled, isSubmitting }) => (
                <Submit label={label} disabled={disabled} isSubmitting={isSubmitting} />
            )}
        />
    );
};
